$(document).ready(function(){
  const customerDefaultCountryCode = $('#header-container').data('country-code');

  let ipCountryCode = null;
  try {
    const ipInfoRaw = window.localStorage.getItem('ip_info');
    const ipInfo = ipInfoRaw ? JSON.parse(ipInfoRaw) : null;
    ipCountryCode = ipInfo ? ipInfo.country : null;
  } catch (e) {
    console.warn('ip_info parse failed', e);
  }

  const euDistributionCountries = theme.settings.euDistributionCountries;
  const restockedLinkEl = $('ul .nav__sublist li a[href="/collections/restocked"]');

  if (customerDefaultCountryCode) {
    if (euDistributionCountries.includes(customerDefaultCountryCode)) {
      restockedLinkEl.attr('href', '/collections/restocked-uk');
    } else {
      restockedLinkEl.attr('href', '/collections/restocked-markham');
    }
  } else if (ipCountryCode) {
    if (euDistributionCountries.includes(ipCountryCode)) {
      restockedLinkEl.attr('href', '/collections/restocked-uk');
    } else {
      restockedLinkEl.attr('href', '/collections/restocked-markham');
    }
  }
});